// This is a request-compatible layer on top of superagent
import superagent from 'superagent/lib/client';

export default function request(options, callback) {
  const url = options.url || options.uri;

  const req = superagent(options.method || 'GET', url);

  req.accept('json');

  options.headers = options.headers || {};

  for (const key of Object.keys(options.headers)) {
    req.set(key, options.headers[key]);
  }

  if (options.qs) {
    req.query(options.qs);
  }

  if (options.body) {
    req.send(options.body);
  }

  if (options.fields) {
    for (const field of Object.keys(options.fields)) {
      req.field(field, options.fields[field]);
    }
  }

  if (options.files) {
    for (const file of Object.keys(options.files)) {
      req.attach(file, options.files[file]);
    }
  }

  if (options.progress) {
    req.on('progress', (ev) => {
      if (ev.lengthComputable) {
        options.progress(ev);
      }
    });
  }

  if (options.withCredentials) {
    req.withCredentials();
  }

  return req.end((err, res) => callback(err, res, res && res.text));
}
